module.exports = "<button *ngIf=\"text\" (click)=\"copy(text)\" type=\"button\" rel=\"tooltip\" title=\"Copy to Clipboard\" class=\"btn btn-danger btn-simple btn-xs\">\n    <i class=\"material-icons\">filter_none</i>\n</button>"


//////////////////
// WEBPACK FOOTER
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/copy/copy.component.html
// module id = ../../../../../src/app/projects/shared/copy/copy.component.html
// module chunks = main